<template>
  <header class="main-header">
    <div class="main-header-container">
      <div class="main-header-logos">
        <a class="main-header-oxfam" target="_blank" href="https://oxfam.org.br/">
          <svg class="main-header-oxfam-logo">
            <use xlink:href="#oxfam-logo" />
          </svg>
        </a>

        <router-link id="header-valor-do-seu-imposto" class="main-header-logo" to="/">
          O Valor do seu <span>impo$to</span>
        </router-link>
      </div>

      <ul class="main-header-menu">
        <li class="main-header-menu__link">
          <router-link id="header-do-que-estamos-falando" to="/do-que-estamos-falando">
            Do que <span>estamos falando</span>
          </router-link>
        </li>

        <li class="main-header-menu__link">
          <router-link id="header-reforma-tributaria" to="/reforma-tributaria">
            Reforma <span>tributária</span>
          </router-link>
        </li>

        <li class="main-header-menu__link">
          <router-link id="header-como-fizemos-as-contas" to="/como-fizemos-as-contas">
            Como fizemos <span>as contas</span>
          </router-link>
        </li>

        <li class="main-header-menu__link">
          <router-link id="header-perguntas-e-respostas" to="/perguntas-e-respostas">
            Perguntas <span>& respostas</span>
          </router-link>
        </li>

        <li class="main-header-menu__link main-header-menu__link--highlight">
          <a @click="goToCalculator" id="header-calculadora" to="/calculadora">
            <svg class="main-header-menu__calculator-icon main-header-menu__calculator-icon--black">
              <use xlink:href="#icon-calculator" />
            </svg>
            <svg class="main-header-menu__calculator-icon main-header-menu__calculator-icon--white">
              <use xlink:href="#icon-calculator--white" />
            </svg>
            <span>Calcule aqui o <br/>valor do seu imposto</span>
          </a>
        </li>

        <li @click="toggleOffcanvas" class="main-header-menu__link main-header-menu__link--offcanvas">
          <span></span>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  methods: {
    toggleOffcanvas() {
      this.$store.dispatch('offcanvas/toggle');
    },
    goToCalculator(event) {
      event.preventDefault();

      if (this.$route.name == 'home') {
        window.scrollBy({
          top: window.innerHeight,
          left: 0,
          behavior: 'smooth',
        });
      } else {
        this.$router.push({
          path: '/calculadora',
        });
      }
    },
  },
  computed: {
    areaSlug() {
      return this.$route.meta.areaSlug;
    }
  }
};
</script>

<style lang="scss">
.main-header {
  position: relative;
  width: 100%;
  padding: rem-calc(20);

  z-index: $z-index-header;
  background-color: $minsk;

  @media #{$large-up} {
    position: fixed;
    top: 0;
    left: 0;
  }
}

.main-header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  margin: auto;
  max-width: rem-calc(1105);
}

.main-header-logos {
  display: flex;
  margin-right: rem-calc(10);

  align-items: center;

  @media #{$large-up} {
    margin-right: rem-calc(40);
  }
}

.main-header-oxfam {
  display: none;
  width: rem-calc(62);
  height: rem-calc(60);

  margin-right: rem-calc(20);
  padding-right: rem-calc(19);

  border-right: 1px solid rgba($white, 0.1);

  @media #{$large-up} {
    display: block;
  }
}

.main-header-oxfam-logo {
  width: 100%;
  height: 100%;
}

.main-header-logo {
  color: $white;
  font-size: rem-calc(6);
  font-family: $font-family--header;
  line-height: rem-calc(10);
  text-transform: uppercase;

  transition: color ease 0.3s;

  &:hover {
    color: $turmeric;
  }

  @media #{$large-up} {
    font-size: rem-calc(14);
    line-height: rem-calc(20);
    font-family: $font-family--header;
  }

  span {
    display: block;
    font-size: rem-calc(14);

    @media #{$large-up} {
      font-size: rem-calc(30);
      font-family: $font-family--header;
    }
  }
}

.main-header-menu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 770px;
}

.main-header-menu__link {
  display: none;
  margin: rem-calc(0 10);

  @media #{$large-up} {
    margin: rem-calc(0 10);
  }

  @media #{$xlarge-up} {
    margin: rem-calc(0 20);
  }

  &:last-child {
    margin-right: 0;
  }

  a {
    color: $white;
    font-size: rem-calc(12);
    line-height: rem-calc(12);
    font-family: 'oxfam-regular';
    font-weight: 600;

    transition: color 0.3s ease;

    @media #{$large-up} {
      font-size: rem-calc(16);
      line-height: rem-calc(20);
    }

    &.router-link-active {
      color: $turmeric;
    }

    &:hover {
      color: $turmeric;
    }
  }

  span {
    display: block;
  }

  @media #{$large-up} {
    display: block;
  }
}

.main-header-menu__link--highlight {
  display: block;
  margin-left: 0;

  @media #{$large-up} {
    margin-right: 0;
    margin-left: rem-calc(20);
  }

  a {
    display: flex;
    align-items: center;
    padding: rem-calc(10);

    border: 2px solid $turmeric;
    border-radius: rem-calc(30);
    cursor: pointer;

    transition: border-color 0.3s ease;

    @media #{$large-up} {
      padding: rem-calc(10 20);
    }

    span {
      color: $turmeric;

      transition: color 0.3s ease;
    }

    &:hover {
      border-color: $white;

      span {
        color: $white;
      }

      .main-header-menu__calculator-icon--black {
        display: none;
      }

      .main-header-menu__calculator-icon--white {
        display: block;
      }
    }
  }
}

.main-header-menu__link--offcanvas {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  width: rem-calc(17);
  height: rem-calc(12);
  cursor: pointer;

  @media #{$large-up} {
    display: none;
  }

  &:before,
  &:after {
    content: '';
    width: 100%;
    height: rem-calc(1);
    background-color: $white;
  }

  span {
    width: 100%;
    height: rem-calc(1);
    background-color: $white;
  }
}

.main-header-menu__calculator-icon {
  width: rem-calc(20);
  height: rem-calc(27);

  margin-right: rem-calc(10);
}

.main-header-menu__calculator-icon--white {
  display: none;
}
</style>
